import api from "../../../";
import type { ApiResponse } from "../../../types";
import type { PaginatedResponse } from "../types";
import type {
  CommunityAnswer,
  GetCommunityAnswerByIdParams,
  GetCommunityAnswersParams,
  GetMyCommunityAnswersParams,
} from "./types";

type ListAnswerApiResult = {
  data?: CommunityAnswer[];
  success?: boolean;
  message?: string;
};

const normalizeAnswersResults = (items: Array<CommunityAnswer | ListAnswerApiResult>): CommunityAnswer[] => {
  if (!Array.isArray(items)) return [];

  return items.flatMap((item) => {
    if ("id" in item) return [item as CommunityAnswer];
    return Array.isArray(item.data) ? item.data : [];
  });
};

export const getCommunityAnswers = async ({ params }: GetCommunityAnswersParams): Promise<PaginatedResponse<CommunityAnswer>> => {
  return await api.get<PaginatedResponse<CommunityAnswer | ListAnswerApiResult>>("/admin/sepehr/answers/", params ? { params } : {})
    .then((res) => ({
      ...res.data,
      results: normalizeAnswersResults(res.data.results || []),
    }))
    .catch(() => ({
      count: 0,
      next: null,
      previous: null,
      results: [],
    }));
};

export const getCommunityAnswerById = async ({ id }: GetCommunityAnswerByIdParams): Promise<CommunityAnswer | null> => {
  return await api.get<ApiResponse<CommunityAnswer>>(`/admin/sepehr/answers/${id}/`)
    .then((res) => res.data.data)
    .catch(() => null);
};

export const getMyCommunityAnswers = async ({ id }: GetMyCommunityAnswersParams = {}): Promise<CommunityAnswer[]> => {
  return await api.get<ApiResponse<CommunityAnswer[]>>("/community/answers/me/", {
    params: id ? { id } : undefined,
  })
    .then((res) => res.data.data)
    .catch(() => []);
};

